export function initializeContactHeadband() {
  const langAttributeValue = document.documentElement.lang;

  $(".block-contact-headband select").on("change", function () {
    if (langAttributeValue.substring(0, 2) !== "fr") {
      window.location.replace(
        "/" +
          langAttributeValue.substring(0, 2) +
          "/contactez-nous/?request-type=" +
          this.value
      );
    } else {
      window.location.replace("/contactez-nous/?request-type=" + this.value);
    }
  });
}
